const detectMobileBrowser = () => {
  // https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return (
    toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    }) ||
    // iPad on iOS 13+ in desktop mode - reports as "Mac" but has touch capability
    // Primary: maxTouchPoints > 1 is more reliable on newer iPadOS
    // Fallback: ontouchend check for older versions
    (navigator.userAgent.includes("Mac") &&
      (navigator.maxTouchPoints > 1 || "ontouchend" in document))
  );
};

export default detectMobileBrowser;

// Warning: because this is only set once, you'll need to refresh the page to change whether isMobileBrowser is true/false
export const isMobileBrowser = detectMobileBrowser();
